import { bpProps, CheckboxInput } from '@teespring/ts-components';
import { func } from 'prop-types';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useServiceAgreement } from 'hooks';
import { addToast, fetchHeaderUserData } from 'redux/actions';
import ModalTemplate from 'components/ModalTemplate';
import { IS_PRODUCTION, SUPPORT_URLS } from '../../constants';
import './TermsOfServiceModal.scss';

export const TERMS_OF_SERVICE_MODAL_ID = 'terms-of-service-modal';

export const TermsOfServiceModal = ({ handleClose }) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state);
  const { user: headerUser } = useSelector((state) => state.header);
  const { bpIsGT } = useSelector((state) => ({ ...bpProps(state) }));

  const [termsRead, setTermsRead] = useState(false);
  const [isAgreeing, setIsAgreeing] = useState(false);
  const { legalNames, signAgreement } = useServiceAgreement(user);

  const agreeToTerms = async () => {
    setIsAgreeing(true);
    try {
      await signAgreement(legalNames.DASHBOARD_TERMS_OF_SERVICE_AGREEMENT);
      await dispatch(fetchHeaderUserData(user.userId));
      handleClose();

      // Keep appearing to "load" the agree after we have confirmation and use
      // the modal close as the "complete" action.
    } catch (e) {
      // On error, stop the "load" so that the user can try again
      setIsAgreeing(false);
      dispatch(addToast(String(e), 'danger'));
    }
  };

  const { tosGrace } = headerUser;

  const currentDomain = IS_PRODUCTION ? 'teespring.com' : 'teedown.com';
  const payoutsLink = `https://${currentDomain}/dashboard/payouts`;
  const settingsLink = `https://${currentDomain}/dashboard/settings`;

  return (
    <ModalTemplate
      modalTitle="We've changed our Terms of Service"
      modalTitleAlign={bpIsGT('mobileLg') ? 'center' : 'left'}
      modalBtnText='Agree and continue'
      modalClose={handleClose}
      modalHideCancelButton={true}
      modalBtnDisabled={!termsRead}
      modalBtnLoading={isAgreeing}
      modalHideCloseButton={!tosGrace}
      modalBtnAction={async () => {
        await agreeToTerms();
      }}
      modalContent={
        <div className='terms_of_service__wrapper'>
          <div className='terms_of_service__content'>
            {"Spring's updated "}
            <a
              href='https://amaze.co/policies/spring-terms-new'
              target='_blank'
              className='typ--link'
              rel='noreferrer'
            >
              Terms of Service
            </a>
            {
              ' will be effective on August 20, 2025. By clicking "agree and continue," you acknowledge you have read and agree to the new terms.'
            }
            <br />
            <br />
            {
              'If you would like to access your account without accepting the new terms, you can: '
            }
            <br />
            <br />
            {'• Access your '}
            <a
              onClick={() => {
                window.location.href = payoutsLink;
              }}
              className='typ--link-quiet'
              style={{ cursor: 'pointer', textDecoration: 'underline' }}
            >
              payouts
            </a>
            {' to collect any outstanding earnings'}
            <br />
            {'• Visit your '}
            <a
              onClick={() => {
                window.location.href = settingsLink;
              }}
              className='typ--link-quiet'
              style={{ cursor: 'pointer', textDecoration: 'underline' }}
            >
              account settings
            </a>
            {' to manage or close your account'}
            <br />
            <br />
            {
              "If you have any questions regarding Spring's updated Terms of Service, please contact support through our "
            }
            <a
              href={SUPPORT_URLS.creatorSupportHome}
              className='typ--link-quiet'
              target='_blank'
              rel='noreferrer'
            >
              Creator Support page
            </a>
            {'.'}
          </div>
          <div className='terms-checkbox'>
            <CheckboxInput
              id='terms-read'
              name='terms-read'
              checked={termsRead}
              onChange={(checked) => setTermsRead(checked)}
              title="I have read, understand, and agree to Spring's updated Terms of Service."
            />
          </div>
        </div>
      }
    />
  );
};

TermsOfServiceModal.propTypes = {
  handleClose: func.isRequired
};

export default TermsOfServiceModal;
